<template>
  <div>
    <v-form :disabled="is_terminated" v-model="applicationForm" :readonly="readonly || !currentUser.privileges.canEditApplications">
    <!-- PERSONAL INFORMATION -->
    <div>
      <p v-if="!currentUser.privileges.canEditApplications" class="red--text">You do not have enough permissions to edit this application.</p>

      <p class="font-weight-medium text-left">Personal Information</p>
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="6" v-if="!readonly">
              <v-file-input
                dense
                color="primary"
                accept="image/*"
                counter
                label="Upload Student Picture"
                prepend-icon="mdi-paperclip"
                @change="onPicChange"
                outlined
                class="rounded-input"
                :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip v-if="index < 2" color="primary" dark label small>
                    {{ text }}
                  </v-chip>
                  <span
                    v-else-if="index === 2"
                    class="overline grey--text text--darken-3 mx-2"
                  >
                    +{{ files.length - 2 }} File(s)
                  </span>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="3">
              <v-img
                :src=" studentImageFileBase || this.applicationDetails.profile_pic || endpoints.defaultProfileImage"
                aspect-ratio="1"
                height="200px"
                class="grey lighten-2 mb-4"
              ></v-img>
            </v-col>
          </v-row>
          
          <v-row justify="center">
            <v-btn 
              class="my-4" 
              color="primary" 
              v-if="enquiryDetails!=null && !this.is_editing && !readonly && letCopy"
              @click="copyFromEnquiryDetails"
            >
              Copy From Enquiry Details
            </v-btn>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="* First Name"
                placeholder="eg. John"
                outlined
                class="rounded-input"
                v-model="applicationDetails.candidate_first_name"
                :rules="[rules.charsOnly, rules.nameLength, rules.required]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Middle Name"
                placeholder="eg. Davis"
                outlined
                class="rounded-input"
                v-model="applicationDetails.candidate_middle_name"
                :rules="[rules.charsOnly, rules.nameLength]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Last Name"
                placeholder="eg. Doe"
                outlined
                class="rounded-input"
                v-model="applicationDetails.candidate_last_name"
                :rules="[rules.charsOnly, rules.nameLength]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="* Father's Name"
                placeholder="eg. Davis"
                outlined
                class="rounded-input"
                v-model="applicationDetails.father_name"
                :rules="[rules.charsOnly, rules.nameLength, rules.required]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="* Mother's Name"
                placeholder="eg. Jane"
                outlined
                class="rounded-input"
                v-model="applicationDetails.mother_name"
                :rules="[rules.charsOnly, rules.nameLength, rules.required]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="genders"
                label="* Gender"
                v-model="applicationDetails.gender"
                :rules="[rules.required]"
                item-text="display"
                item-value="value"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
    </div>
    <!-- CONTACT INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Contact Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="* Phone number"
                :items="genders"
                placeholder="eg. 9876543210"
                outlined
                class="rounded-input"
                v-model="applicationDetails.mobileno"
                :rules="[rules.required, rules.numbersOnly, rules.phoneNumberLength]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Alternate Number"
                placeholder="eg. 9876543210"
                v-model="applicationDetails.alternate_mobileno"
                :rules="[rules.numbersOnly, rules.phoneNumberLength]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Email*"
                placeholder="eg. abc@gmail.com"
                v-model="applicationDetails.email"
                :rules="[rules.email]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- ACADEMIC INFORMATION -->

    <div>
      <p class="font-weight-medium text-left">Academic Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="class_standards"
                label="* Standard of Admission"
                v-model="applicationDetails.class_standard"
                outlined
                class="rounded-input"
                item-text="display"
                item-value="id"
                :rules="[rules.required]"
                return-object
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Batch"
                placeholder="eg. 2020-2021"
                outlined
                v-if="applicationDetails.class_standard && applicationDetails.class_standard.academic_session"
                class="rounded-input"
                v-model="applicationDetails.class_standard.academic_session.title"
                dense
                readonly
                :hint="readonly?'You can only edit in application details' : 'Can be changed by selecting different standard of admission'"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- ACADEMIC HISTORY-->
    <div>
      <p class="font-weight-medium text-left">Academic History</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous School"
                placeholder="eg. St.Xavier's School"
                :rules="[rules.length30]"
                v-model="applicationDetails.previous_school_name"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std"
                placeholder="eg. 7th STD"
                v-model="applicationDetails.previous_standard"
                outlined
                class="rounded-input"
                :rules="[rules.length10]"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Previous Std Percentage"
                :rules="[rules.percentage]"
                placeholder="eg. 92.40"
                v-model="applicationDetails.previous_standard_percentage"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- Other Info-->
    <div>
      <p class="font-weight-medium text-left">Other Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-checkbox
                v-model="applicationDetails.is_specially_abled"
                label="Specially Abled Candidate?"
                :hint="readonly?'You can only edit in application details' : null"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- BIRTH AND NATIONALITY INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">
        Birth & Nationality Information
      </p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :hint="readonly?'You can only edit in application details' : null"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedDate(applicationDetails.date_of_birth)"
                      append-icon="fas fa-calendar"
                      readonly
                      outlined
                      label="Date of Birth"
                      class="rounded-input"
                      dense
                      v-bind="attrs"
                      v-on="on"
                      hide-details="auto"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="applicationDetails.date_of_birth"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Place of birth"
                placeholder="eg. Mumbai"
                v-model="applicationDetails.place_of_birth"
                :rules="[ rules.length30 ]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Nationality"
                placeholder="eg. Indian"
                :rules="[ rules.length30 ]"
                outlined
                class="rounded-input"
                v-model="applicationDetails.nationality"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Aadhaar Number"
                placeholder="XXXX XXXX XXXX XXXX"
                v-model="applicationDetails.aadhaar_card_number"
                :rules="[ rules.aadhar, rules.numbersOnly ]"
                counter="12"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Mother Tongue"
                placeholder="eg. Marathi"
                v-model="applicationDetails.mother_tongue"
                :rules="[ rules.length10 ]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Religion"
                v-model="applicationDetails.religion"
                :rules="[ rules.length10 ]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Caste"
                :rules="[ rules.length10 ]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>

    <!-- ADDRESS INFORMATION -->
    <div>
      <p class="font-weight-medium text-left">Address Information</p>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="8">
              <v-textarea
                label="Address (House no. / Street / Lane)"
                placeholder="eg. Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Bangalore-560016"
                v-model="applicationDetails.address"
                outlined
                class="rounded-input"
                rows="3"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-textarea>
            </v-col>

            <!-- <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Landmark (Area)"
                placeholder=""
                outlined
                class="rounded-input"
                dense
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="District"
                placeholder="eg. Thane"
                v-model="applicationDetails.district"
                :rules="[ rules.length10 ]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="State"
                placeholder="eg. Maharashtra"
                v-model="applicationDetails.state"
                :rules="[ rules.length30 ]"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Pincode"
                placeholder="eg. 400612"
                :rules="[ rules.numbersOnly ]"
                counter="6"
                v-model="applicationDetails.pin_code"
                outlined
                class="rounded-input"
                dense
                :hint="readonly?'You can only edit in application details' : null"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
    </div>
    </v-form>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import ImagePreviewMixin from "@mixins/ImagePreviewMixin";
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import moment from 'moment';

export default {
  name: "ApplicationStepperContent",
  mixins: [ImagePreviewMixin],
  props: {
    applicationDetails: {
      default: () => {
        return {
          profile_pic: null,
          class_standard: {},
          candidate_first_name: null,
          candidate_last_name: null,
          candidate_middle_name: null,
          gender: null,
          previous_school_name: null,
          previous_standard: null,
          previous_standard_percentage: null,
          prevoius_medium_of_study: null,
          mobileno: null,
          alternate_mobileno: null,
          category_type: null,
          category: null,
          is_specially_abled: false,
          note: null,
          father_name: null,
          mother_name: null,
          place_of_birth: null,
          date_of_birth: null,
          blood_group: null,
          aadhaar_card_number: null,
          country_of_citizenship: null,
          mother_tongue: null,
          nationality: null,
          religion: null,
          state: null,
          district: null,
          city_town_village: null,
          address: null,
          pin_code: null,
          state_2: null,
          district_2: null,
          city_town_village_2: null,
          address_2: null,
          pin_code_2: null,
          email: null,
          occupation_of_guardian: null,
          annual_income: null,
          qualification: null
        }
      },
      type: Object
    },
    enquiryDetails: {
      default: () => {},
      type: Object,
    },
    is_terminated: {
      default: true,
      type: Boolean,
    },
    is_from_portal: {
      default: false,
      type: Boolean,
    },
    class_standards : {
      default: () => [],
      type: Array,
    },
    is_editing: {
      default: null,
      type: Boolean,
    },
    // used for evaluation tab
    readonly:{
      default: false,
      type: Boolean,
    },
    admission_id: null,
  },
  data(){
    return {
      applicationForm: true,
      letCopy: true,
      menu: false,
      // profile_pic: null,
      studentImageFileBase: null,
      endpoints: endpoints,
      moment: moment,
      genders: [
        {
          display: "Male",
          value: "M",
        },
        {
          display: "Female",
          value: "F",
        },
        {
          display: "Other",
          value: "O",
        },
      ],
      rules: {
        required: (v) => !!v || "Required",
        fullNameLength: (v) => !v || v?.length<=70 || "Too Long",
        nameLength: (v) => !v || v?.length<=40 || "Max length is 40",
        charsOnly: (v) => !/[^a-zA-Z. ]/.test(v) || "Invalid",
        usernameValidation: (v) => !v || !/[^a-zA-Z0-9.]/.test(v) || "Invalid",
        numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",
        phoneNumberLength: (v) => !v || v?.length == 10 || "Should be 10 Digits",
        emailOnly: (v) => !v ||
          /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/.test(
            v
          ) || "Not a valid email",
        length30 : (v) => !v || v?.length<=30 || "Too long",
        length10: (v) => !v || v?.length<=10 || "Max 10 digits",
        email: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        aadhar: (v) => !v || v.length == 12 || "Invalid Aadhar Number",
        percentage: (v) => /(100(\.0{1,2})?$)|^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$/.test(v)|| !v || "Enter valid percentage"      
      },
      snackbar: {
        visible: false,
        text: "",
      },

    }
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    formattedDate(date) {
      if (!date) return "";
      return moment(date).format("D MMM YYYY");
    },

    async onPicChange(payload){
      // this.setLoading(true);
      const file = payload; 
      if(file){
        this.studentImageFileBase = await Helper.toBase64(file);
      }
      else{
        this.studentImageFileBase = null;
      }
      // this.setLoading(false); 
    },
    copyFromEnquiryDetails(){
      Object.keys(this.enquiryDetails).forEach((key) => this.applicationDetails[key] = this.enquiryDetails[key]);
      this.letCopy = false;
    },
    // Do not TOUCH or change names 
    async saveFormDetails(){
      if(!this.applicationForm){
        alert("Form Not Valid");
        return;
      }
      var url = endpoints.admissions + "application/";
      if(this.studentImageFileBase){
        this.applicationDetails.profile_pic = this.studentImageFileBase;
      }
      var post_body = {
        application_details: this.applicationDetails,
        is_editing: this.is_editing,
        admission_id: this.admission_id,
        has_profile_pic: (this.studentImageFileBase ? true : false )
      }
      var response = await api.call(this.apiEssentials,url,api.Methods.POST, post_body);
      if (response instanceof Error){
        this.setLoading(false);
        this.snackbar.text = "Error saving details";
        this.snackbar.visible = true;
        return;
      }
      // this.$router.push({name: 'EditAdmissionDetails', params: { admission_id: response.id }});
      this.snackbar.text = "Application Successfully Saved!";
      this.snackbar.visible = true;
      this.$emit("save-response",{ step: 2 ,name: 'applicationDetails', value: response});
      this.applicationForm = false;
    },
  },
  watch: {
    // DO NOT TOUCH
    applicationForm(){
      this.$emit("form-change",{ step: 2 ,name: 'applicationForm', is_valid: this.applicationForm});
    },
  },
  created(){
    this.$emit("form-change",{ step: 2 ,name: 'applicationForm', is_valid: this.applicationForm});
  }
};
</script>

<style>
</style>